import { IFeatures } from '@bciti/types';
import { Observable } from 'rxjs';
import { Navigation, OrganisationPayload, OrganisationConfiguration, GetAdminOrganisationAreas, Colour } from '../../global.model';

export abstract class OrganisationService {
    abstract getSubdomain(): Observable<string | undefined>;

    abstract getOrganisations(): Observable<OrganisationPayload[]>;

    abstract getOrganisationNavigation(tag: string): Observable<Navigation>;

    abstract getOrganisationByTag(tag: string): Observable<OrganisationPayload>;

    abstract getOrganisationBySubdomain(subdomain: string): Observable<OrganisationPayload>;

    abstract getOrganisationFromAuth(): Observable<OrganisationPayload | undefined>;

    abstract getOrganisationConfiguration(tag: string): Observable<OrganisationConfiguration>;

    abstract getOrganisationFeaturesConfiguration(tag: string): Observable<IFeatures>;

    abstract getOrganisationAreas(): Observable<GetAdminOrganisationAreas[]>;

    abstract getOrganisationAreasByTag(): Observable<GetAdminOrganisationAreas[]>;

    abstract createOrganisationArea(area: any): Observable<GetAdminOrganisationAreas>;

    abstract updateOrganisationArea(area: any): Observable<GetAdminOrganisationAreas>;

    abstract deleteOrganisationArea(id: string): Observable<any>;

    abstract getOrganisationColour(): Observable<any>;

    abstract setOrganisationColour(orgTag: string, colour: Colour): Observable<any>;
}
